import { HeadingProps } from "../../Types/CommonElementType";

const H2:React.FC<HeadingProps> = (props) => {
  const { children = "" } = props;
  return (
    <h2 {...props} style={props.style}>
      {children}
    </h2>
  );
};

export default H2;
